import { ChatDetail } from "./ChatAction";
import { ChatState } from "./ChatState";
import { createDefaultState } from "./DefaultState";

export function createStateFromMessages(messages: readonly ChatDetail[]): ChatState {
    const def = createDefaultState();
    return {
        ...def,
        connection: {
            ...def.connection,
            connectionStatus: "online"
        },
        accountStatus: "online",
        chats: [...messages],
        isChatting: true,
        visuals: {}
    };
}
